import { render, staticRenderFns } from "./ModalSousRubrique.vue?vue&type=template&id=203d1c88&scoped=true"
import script from "./ModalSousRubrique.vue?vue&type=script&lang=js"
export * from "./ModalSousRubrique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d1c88",
  null
  
)

export default component.exports